const restMetricGroupLabels = Object.freeze({
  send_date: 'RestMetricGroup_SendDate',
  first_send_date: 'RestMetricGroup_FirstSendDate',
  last_send_date: 'RestMetricGroup_LastSendDate',
  mobile_push: 'RestMetricGroup_MobilePush',
  mobile_push_android: 'RestMetricGroup_MobilePushAndroid',
  mobile_push_ios: 'RestMetricGroup_MobilePushIos',
  web_push: 'RestMetricGroup_WebPush',
  inapp: 'RestMetricGroup_Inapp',
  inapp_android: 'RestMetricGroup_InappAndroid',
  inapp_ios: 'RestMetricGroup_InappIos',
  onsite: 'RestMetricGroup_Onsite',
  inbox: 'RestMetricGroup_Inbox',
  email: 'RestMetricGroup_Email',
  sms: 'RestMetricGroup_Sms',
  facebook: 'RestMetricGroup_Facebook',
  whatsapp: 'RestMetricGroup_Whatsapp',
  conversion: 'RestMetricGroup_Conversion',
  goal: 'RestMetricGroup_Goal',
  goals: 'RestMetricGroup_Goals',
  goals_value: 'RestMetricGroup_GoalsValue',
  sent: 'RestMetricGroup_Sent',
  clicked: 'RestMetricGroup_Clicked',
  click_rate: 'RestMetricGroup_ClickRate',
  opened: 'RestMetricGroup_Opened',
  bounced: 'RestMetricGroup_Bounced',
  delivered: 'RestMetricGroup_Delivered',
  unsubscribed: 'RestMetricGroup_Unsubscribed',
  complained: 'RestMetricGroup_Complained',
  open_rate: 'RestMetricGroup_OpenRate',
  sent_unique: 'RestMetricGroup_SentUnique',
  converted_unique: 'RestMetricGroup_ConvertedUnique',
  bounce_rate: 'RestMetricGroup_BounceRate',
  delivery_rate: 'RestMetricGroup_DeliveryRate',
  unsubscribe_rate: 'RestMetricGroup_UnsubscribeRate',
  complaint_rate: 'RestMetricGroup_ComplainRate',
  workflow: 'RestMetricGroup_Workflow',
  arrived: 'RestMetricGroup_Arrived',
  entered: 'RestMetricGroup_Entered',
  delayed: 'RestMetricGroup_Delayed'
})

export { restMetricGroupLabels }



// WEBPACK FOOTER //
// ./src/common/enum/RestMetricGroupEnum.js